module.exports = __webpack_public_path__ + "img/closeup-medicines.686dd6b7.jpeg";